// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Styles the contextual left-nav flyout panel.
 * Provides lightweight SaaS-style panel visuals and subtle fade/slide-in motion.
 */
.left-nav-flyout {
  width: 14rem;
  max-width: 16rem;
  background: #f8fbff;
  border: 1px solid #d7e2f0;
  border-radius: 0.625rem;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.12);
  padding: 0.625rem;
  animation: left-nav-flyout-enter 160ms ease-out;
}

.left-nav-flyout__title {
  margin: 0 0 0.375rem;
  padding: 0 0.25rem;
  font-size: 11pt;
  font-weight: 600;
  color: #334155;
}

.left-nav-flyout__item {
  width: 100%;
  border: 0;
  background: transparent;
  border-radius: 0.5rem;
  text-align: left;
  padding: 0.5rem 0.625rem;
  color: #1f2937;
  cursor: pointer;
  transition: background-color 120ms ease, color 120ms ease;
}

.left-nav-flyout__item:hover,
.left-nav-flyout__item:focus-visible {
  background: #2f7198;
  color: #ffffff;
  outline: none;
}

.left-nav-flyout__item--active {
  background: #004d80;
  color: #ffffff;
  font-weight: 600;
}

.left-nav-flyout__item--active:hover,
.left-nav-flyout__item--active:focus-visible {
  background: #004d80;
  color: #ffffff;
}

@keyframes left-nav-flyout-enter {
  from {
    opacity: 0;
    transform: translateX(-8px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}`, "",{"version":3,"sources":["webpack://./src/modules/navigation/components/left-nav-flyout-menu/left-nav-flyout-menu.component.scss"],"names":[],"mappings":"AAAA;;;EAAA;AAIA;EACI,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,uBAAA;EACA,8CAAA;EACA,iBAAA;EACA,+CAAA;AACJ;;AAEA;EACI,oBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AACJ;;AAEA;EACI,WAAA;EACA,SAAA;EACA,uBAAA;EACA,qBAAA;EACA,gBAAA;EACA,wBAAA;EACA,cAAA;EACA,eAAA;EACA,yDAAA;AACJ;;AAEA;;EAEI,mBAAA;EACA,cAAA;EACA,aAAA;AACJ;;AAEA;EACI,mBAAA;EACA,cAAA;EACA,gBAAA;AACJ;;AAEA;;EAEI,mBAAA;EACA,cAAA;AACJ;;AAEA;EACI;IACI,UAAA;IACA,2BAAA;EACN;EACE;IACI,UAAA;IACA,wBAAA;EACN;AACF","sourcesContent":["/**\n * Styles the contextual left-nav flyout panel.\n * Provides lightweight SaaS-style panel visuals and subtle fade/slide-in motion.\n */\n.left-nav-flyout {\n    width: 14rem;\n    max-width: 16rem;\n    background: #f8fbff;\n    border: 1px solid #d7e2f0;\n    border-radius: 0.625rem;\n    box-shadow: 0 10px 24px rgba(15, 23, 42, 0.12);\n    padding: 0.625rem;\n    animation: left-nav-flyout-enter 160ms ease-out;\n}\n\n.left-nav-flyout__title {\n    margin: 0 0 0.375rem;\n    padding: 0 0.25rem;\n    font-size: 11pt;\n    font-weight: 600;\n    color: #334155;\n}\n\n.left-nav-flyout__item {\n    width: 100%;\n    border: 0;\n    background: transparent;\n    border-radius: 0.5rem;\n    text-align: left;\n    padding: 0.5rem 0.625rem;\n    color: #1f2937;\n    cursor: pointer;\n    transition: background-color 120ms ease, color 120ms ease;\n}\n\n.left-nav-flyout__item:hover,\n.left-nav-flyout__item:focus-visible {\n    background: #2f7198;\n    color: #ffffff;\n    outline: none;\n}\n\n.left-nav-flyout__item--active {\n    background: #004d80;\n    color: #ffffff;\n    font-weight: 600;\n}\n\n.left-nav-flyout__item--active:hover,\n.left-nav-flyout__item--active:focus-visible {\n    background: #004d80;\n    color: #ffffff;\n}\n\n@keyframes left-nav-flyout-enter {\n    from {\n        opacity: 0;\n        transform: translateX(-8px);\n    }\n    to {\n        opacity: 1;\n        transform: translateX(0);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
